<lcs-loading-overlay
   class="flex-dir-col"
   [show]="callState | lcsCallState : 'loading'"
   *ndtErrorPage="!(callState | lcsCallState : 'error'); entityName: 'Device'"
   [show]="callState | lcsCallState : 'loading'"
>
   <div class="detail-page-headerbar">
      <div class="left">
         <div class="page-heading">
            <h2 class="page-title">
               Phone - {{ device?.deviceTypeId }}
               @if (device && (device.isHacked || device.isFraud)) {
               <phone-issues-chip-and-menu class="issues-chip" [device]="this._device"></phone-issues-chip-and-menu>
               }
            </h2>
         </div>
      </div>
      <div class="right context-actions">
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="updateDetailsMenu"
            matTooltip="Info"
            aria-label="Phone Info"
            id="device-detail-info"
         >
            <mat-icon>info</mat-icon>
         </button>
         @if ( isSystemUser && (devicePrivileges.canDelete || device?.account?.accountId || device?.isHacked ||
         device?.isFraud) ) {
         <button
            type="button"
            mat-button
            [matMenuTriggerFor]="deviceMenu"
            aria-label="Phone Actions"
            matTooltip="More Actions"
            id="device-detail-more-actions"
         >
            <mat-icon>more_horiz</mat-icon>
         </button>
         }
      </div>
   </div>
   <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <ndt-two-column-layout>
         <div ndtLeftColumn>
            <div class="details-wrapper">
               <h4>ZTP Info</h4>
               <ng-container>
                  <h5>ZT</h5>
                  <div class="detail-item typeId">{{ device?.ztStatus ? 'Yes' : 'No' }}</div>
               </ng-container>
               @if (device?.account?.accountId) {
               <h5>ZTP Status</h5>
               <div class="detail-item">{{ device?.ztStatus ? device.lastZtResponse : 'N/A' }}</div>
               } @if (device?.account?.accountId) {
               <h5>Last Firmware Reported</h5>
               <div class="detail-item typeId">{{ device?.ztStatus ? device.lastFirmwareReported : 'N/A' }}</div>
               } @if (device?.account?.accountId) {
               <h5>Last Provisioned On</h5>
               <div class="detail-item typeId">{{
                  device?.ztStatus ? (device.lastProvisionedDate | date : 'MM/dd/yyyy hh:mm aa') : 'N/A'
               }}</div>
               } @if (distinctInternalIps.length > 0 && isSystemUser) {
               <h5>{{ distinctInternalIps.length > 1 ? 'Internal IPs' : 'Internal IP' }}</h5>
               @for (ip of distinctInternalIps; track ip) {
               <div class="detail-item typeId">{{ ip }}</div>
               } } @if (distinctExternalIps.length > 0 && isSystemUser) {
               <h5>{{ distinctExternalIps.length > 1 ? 'External IPs' : 'External IP' }}</h5>
               @for (ip of distinctExternalIps; track ip) {
               <div class="detail-item typeId">{{ ip }}</div>
               } } @if (distinctUserAgents.length > 0 && isSystemUser) {
               <h5>{{ distinctUserAgents.length > 1 ? 'User Agents' : 'User Agent' }}</h5>
               @for (ua of distinctUserAgents; track ua) {
               <div class="detail-item typeId">{{ ua }}</div>
               } }
            </div>
         </div>
         <div ndtRightColumn>
            <div class="detail-right-column">
               @if (isSystemUser) {
               <mat-form-field class="flex-half">
                  <mat-label>Phone Model</mat-label>
                  <input
                     matInput
                     autocomplete="off"
                     type="text"
                     formControlName="deviceTypeId"
                     id="deviceTypeId"
                     [value]="device?.deviceTypeId"
                     readonly="true"
                     required
                  />
                  @if (form.get('deviceTypeId')?.hasError('required')) {
                  <mat-error> Device Type is Required. </mat-error>
                  }
               </mat-form-field>
               } @if (isSystemUser && !device?.account?.accountId) {
               <mat-form-field class="flex-full">
                  <mat-label>Account</mat-label>
                  <input
                     autocomplete="off"
                     [lcsSingleSelect]="accountSelect"
                     ndtAccountSelect
                     formControlName="account"
                     id="account"
                  />
                  <ndt-account-select #accountSelect isIncludeEmptyOption="true"></ndt-account-select>
               </mat-form-field>
               }
               <mat-form-field class="flex-full">
                  <mat-label>Mac Address</mat-label>
                  <input
                     matInput
                     autocomplete="off"
                     type="text"
                     [value]="device?.macAddress"
                     formControlName="macAddress"
                     id="macAddress"
                     readonly="true"
                  />
                  @if (form.get('macAddress')?.hasError('required')) {
                  <mat-error> Mac Address is Required. </mat-error>
                  } @if (form.get('macAddress')?.hasError('pattern')) {
                  <mat-error> Incorrect Mac Address Format, must be 12 characters containing [a-f,A-F,0-9] </mat-error>
                  }
               </mat-form-field>
               <mat-form-field class="flex-full">
                  <mat-label>Description</mat-label>
                  <input
                     matInput
                     autocomplete="off"
                     type="text"
                     [value]="device?.description"
                     formControlName="description"
                     id="description"
                  />
               </mat-form-field>
               @if (device?.deviceTypeId == DeviceTypes.RoveB2 || device?.deviceTypeId == DeviceTypes.RoveB4) {
               <div class="flex-half">
                  <ndt-basestation-chip-input
                     [devices]="device?.account?.extensionsConnection.items || []"
                     formControlName="baseStationHandsets"
                     [extensionIdsToExclude]="[]"
                  ></ndt-basestation-chip-input>
               </div>
               }
            </div>
         </div>
      </ndt-two-column-layout>
      <ndt-form-footer (cancel)="onCancel()" [visible]="form.dirty" [callState]="callState"></ndt-form-footer>
   </form>
</lcs-loading-overlay>
<mat-menu #deviceMenu="matMenu">
   @if (isSystemUser && device?.account?.accountId) {
   <button
      mat-menu-item
      type="button"
      (click)="onReleaseToAccountClick(device); $event.preventDefault(); $event.stopPropagation()"
      id="device-release-to-account"
   >
      Release to Account
   </button>
   } @if (device?.account?.accountId) {
   <button mat-menu-item type="button" (click)="onReleaseDeviceClick()" id="device-release-to-system">
      Release to System
   </button>
   } @if (devicePrivileges.canDelete && isSystemUser) {
   <button mat-menu-item type="button" (click)="onDeleteClick()" id="device-delete"> Delete Phone </button>
   } @if (isSystemUser) {
   <button type="button" mat-menu-item (click)="rebootPhoneClick(device)"> Reboot Phone </button>
   } @if (device?.ztStatus === true && isSystemUser) {
   <button type="button" mat-menu-item (click)="resetPhoneZtpClick(device)"> Factory Reset Phone </button>
   } @if (device?.isHacked || device?.isFraud) {
   <button mat-menu-item type="button" id="device-details" (click)="resetHackedAndFraudDevice(device)">
      Resolve issue
   </button>
   }
</mat-menu>
<mat-menu #updateDetailsMenu="matMenu">
   <update-details
      [createUser]="device?.createUser"
      [createDate]="device?.createDate"
      [updateUser]="device?.updateUser"
      [updateDate]="device?.updateDate"
   ></update-details>
</mat-menu>
